import React, { useState } from 'react'
import {
  Container,
  TextField,
  FormControl,
  Typography,
  Box,
  MenuItem,
  Select,
  InputLabel,
  Button,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { nameSuccess } from '../slices/authSlice'
import { getData, updateData, addRequestsData } from '../api/indexedDBHandler'

const UserName = () => {
  const dispatch = useDispatch()
  const [category, setСategory] = useState('БР')
  const [name, setName] = useState('')
  const [surname, setSurname] = useState('')
  const [patronymic, setPatronymic] = useState('')
  const [errorname, setErrorname] = useState(false)
  const [errorsurname, setErrorsurname] = useState(false)
  const [loading, setLoading] = useState(false)
  const saveUserName = async () => {
    var isNext = true
    if (name === '') {
      setErrorname(true)
      isNext = false
    } else setErrorname(false)

    if (surname === '') {
      setErrorsurname(true)
      isNext = false
    } else setErrorsurname(false)
    if (isNext) {
      const results = await getData('user', 'created', true)
      const { key, value } = results[0]
      console.log(key, value)
      // const userData = JSON.parse(localStorage.getItem("user"));
      // const user = {
      //   surname,
      //   patronymic,
      //   name,
      //   rank: category,
      //   token: userData.token,
      //   phone: userData.phone,
      // };
      setLoading(true)
      await updateData('user', key, {
        rank: category,
        surname,
        patronymic,
        name,
      })

      await addRequestsData('requests', {
        url: 'user/saveUserName.php',
        rank: category,
        surname,
        patronymic,
        name,
        token: value.token,
        phone: value.phone,
        requestKey: `${value.token}_${value.phone}_${new Date().getTime()}`,
      })
      dispatch(nameSuccess(true))
    }
  }

  const handleChangeСategory = (e) => {
    setСategory(e.target.value)
  }
  const onChangeSetName = (e) => {
    setName(e.target.value.trim())
  }
  const onChangeSetSurname = (e) => {
    setSurname(e.target.value.trim())
  }
  const onChangeSetPatronymic = (e) => {
    setPatronymic(e.target.value.trim())
  }
  return (
    <Container maxWidth="sm">
      <Box mt={5} display="flex" flexDirection="column" alignItems="center">
        <Typography variant="body1" display="block" gutterBottom>
          Введите ваши имя, фамилию и отчество.
        </Typography>

        <TextField
          error={errorsurname}
          sx={{ mt: 1 }}
          fullWidth
          value={surname}
          id="outlined-basic"
          label="Фамилия"
          variant="outlined"
          onChange={onChangeSetSurname}
        />

        <TextField
          error={errorname}
          sx={{ mt: 1 }}
          fullWidth
          value={name}
          id="outlined-basic"
          label="Имя"
          variant="outlined"
          onChange={onChangeSetName}
        />

        <TextField
          sx={{ mt: 1 }}
          fullWidth
          value={patronymic}
          id="outlined-basic"
          label="Отчество"
          variant="outlined"
          onChange={onChangeSetPatronymic}
        />
        <Typography variant="body1" display="block" gutterBottom sx={{ mt: 3 }}>
          Выберите свою судейскую категорию. Если её нет, оставьте БР.
        </Typography>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-label">Категория</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={category}
            label="Age"
            onChange={handleChangeСategory}
          >
            <MenuItem value={'БР'}>БР</MenuItem>
            <MenuItem value={'ЮС'}>ЮС</MenuItem>
            <MenuItem value={'СС3К'}>СС3К</MenuItem>
            <MenuItem value={'СС2К'}>СС2К</MenuItem>
            <MenuItem value={'СС1К'}>СС1К</MenuItem>
            <MenuItem value={'ССВК'}>ССВК</MenuItem>
            <MenuItem value={'ССМК'}>ССМК</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="success"
          disabled={loading}
          onClick={saveUserName}
          sx={{
            borderRadius: '20px',
            padding: '10px 20px',
          }}
        >
          Сохранить
        </Button>
      </Box>
    </Container>
  )
}
export default UserName
// Сделай скрипт для реакт проекта - который будет принимать в себя все запросы к внешнему серверу - сохранять их в базе данных браузера, дзатем если есть интернет он должен отправить их на внешний сервер, подучить ответ и вернуть его компоненту который делал запрос. Удалить этот запрос из таблицы
